const signupButton = document.querySelector("#signup-demo-fixed");
const heroSectionSignup = document.querySelector("#hero-section-signup");
const mainnav = document.querySelector("#mainnav");
const hideDemoButton = window.hideDemoButton;

if (
  "IntersectionObserver" in window &&
  "IntersectionObserverEntry" in window &&
  "intersectionRatio" in window.IntersectionObserverEntry.prototype
) {
  let observer = new IntersectionObserver(entries => {
  if (!hideDemoButton) {
    if (entries[0].boundingClientRect.y < 0) {
      signupButton.classList.remove("lg:hidden", "fadeOut");
      signupButton.classList.add("fadeIn");
    } else {
      signupButton.classList.add("fadeOut");
      signupButton.classList.remove("fadeIn");
    }
  }
  if (heroSectionSignup) {
    if (entries[0].boundingClientRect.y < 0) {
      mainnav.classList.remove("hidden", "fadeOut");
      mainnav.classList.add("fadeIn");
    
  } else {
      mainnav.classList.add("fadeOut");
      mainnav.classList.remove("fadeIn");
  }
  }
});
if (heroSectionSignup) {
  observer.observe(document.querySelector("#hero-section-pixel-anchor"));
} else
observer.observe(document.querySelector("#top-of-site-pixel-anchor"));
}